export default {
  authError: null,
  isAuthValidate: null,
  popupType: null,
  currentPhone: null,
  isPopup: false,
  regError: null,
  savePhone: ''
}



// WEBPACK FOOTER //
// ./src/components/store/modules/auth/state.js